import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getPersonalizedSearchPageRoute } from 'site-modules/shared/utils/personalized-search/personalized-search-utils';
import { venomHistory } from 'client/utils/history/venom-history';
import { objectToQueryString } from 'site-modules/shared/utils/string';
import { pick } from 'lodash-es';
import {
  SEARCH_KEY_QUERY_PARAM,
  SEARCH_QUERY_PARAM,
} from 'site-modules/shared/constants/personalized-search/personalized-search';
import { usePrevious } from 'site-modules/shared/hooks/use-previous';

export function PersonalizedSearchRedirect({ isError = false, searchId = undefined, location = undefined }) {
  const key = location?.query?.[SEARCH_KEY_QUERY_PARAM];
  const query = location?.query?.[SEARCH_QUERY_PARAM]?.trim();
  const prevQuery = usePrevious(query);
  const prevSearchId = usePrevious(searchId);

  const redirect = useCallback(
    searchIdValue => {
      const params = { ...(location?.query ?? {}) };

      params[SEARCH_KEY_QUERY_PARAM] = searchIdValue;
      venomHistory.replace(`${getPersonalizedSearchPageRoute()}?${objectToQueryString(params)}`);
    },
    [location?.query]
  );

  /*
   * This useEffect is for the case when the same query is submitted.
   * When new submit happens "key" param disappears from the url and new "q" appears. If "q" param stay the same,
   * then submission hook will not react and will not update url with the correct key. And we append key manually
   */
  useEffect(() => {
    if (!key && prevQuery && prevQuery === query) {
      redirect(prevSearchId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    const params = location?.query ?? {};

    if (isError) {
      venomHistory.replace(
        `${getPersonalizedSearchPageRoute()}?${objectToQueryString(pick(params, [SEARCH_KEY_QUERY_PARAM, SEARCH_QUERY_PARAM]))}`
      );
      return;
    }

    if (!searchId) {
      return;
    }

    redirect(searchId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchId]);

  return null;
}

PersonalizedSearchRedirect.propTypes = {
  isError: PropTypes.bool,
  searchId: PropTypes.string,
  location: PropTypes.shape({ query: PropTypes.shape({}) }),
};
